import formBase from './formBase';

const formBaseRecaptcha = {
    mixins: [formBase],

    methods: {
        async submit(path) {
            await this.$recaptchaLoaded()
            const token = await this.$recaptcha(this.$options.name)
            this.formData._recaptcha = token

            const baseSubmit = formBase.methods.submit.bind(this)
            baseSubmit(path)
        },
    },
}

export default formBaseRecaptcha;